import {
  Draggable,
  DraggableProvided,
  DraggableStateSnapshot,
} from "@hello-pangea/dnd";
import { IColumn, IItem } from "../types";
import ItemList from "./ItemList";
import { useContext, useState } from "react";
import { BoardContext } from "../context";

interface ColumnProps {
  index: number;
  column: IColumn;
}

const Column = (props: ColumnProps) => {
  const { index, column } = props;
  const [isEditing, setIsEditing] = useState(false);
  const [showAddButton, setShowAddButton] = useState(false);
  const { changeColumnTitle, addItem } = useContext(BoardContext);

  const handleTitleClick = () => {
    setIsEditing(true);
  };

  const handleTitleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    changeColumnTitle(column.id, e.target.value);
  };

  const handleTitleBlur = () => {
    setIsEditing(false);
  };

  const onMouseEnter = () => {
    setShowAddButton(true);
  };

  const onMouseLeave = () => {
    setShowAddButton(false);
  };

  return (
    <Draggable draggableId={column.id} index={index}>
      {(provided: DraggableProvided, snapshot: DraggableStateSnapshot) => (
        <div
          className="flex flex-col m-2 bg-slate-50 border border-gray-300 rounded-md"
          ref={provided.innerRef}
          {...provided.draggableProps}
          onMouseEnter={onMouseEnter}
          onMouseLeave={onMouseLeave}
        >
          <div
            className={`flex items-center justify-center mb-2 p-2 border-b select-none hover:bg-slate-200 ${
              snapshot.isDragging ? "bg-slate-200" : ""
            }`}
            {...provided.dragHandleProps}
          >
            {isEditing ? (
              <input
                className="text-center bg-slate-50 text-lg"
                type="text"
                value={column.title}
                onChange={handleTitleChange}
                onBlur={handleTitleBlur}
                autoFocus
              />
            ) : (
              <h1 className="text-lg" onClick={handleTitleClick}>
                {column.title}
              </h1>
            )}
          </div>
          <ItemList items={column.items} title={column.title} id={column.id} />
          {showAddButton ? (
            <button
              onClick={() => addItem(column.id)}
              className="flex bg-white m-2 p-2 min-h-4 border border-dashed border-gray-500 rounded-md hover:border-solid hover:bg-gray-100 select-none"
            >
              <p>Add item</p>
            </button>
          ) : null}
        </div>
      )}
    </Draggable>
  );
};

export default Column;
